﻿window.cBuilderEmailWidgetCtrlBtValide = function cBuilderEmailWidgetCtrlBtValide(option) {
    var Me = this;

    // =========================================================
    // Héritage
    // =========================================================

    window.cBuilderEmailWidgetCtrl.call(this, option);


    // =========================================================
    // Propriétés spécifiques
    // =========================================================

    this.nomWidget = "dxwidgetformbtvalide"
    this.icone = "fas fa-square-caret-right";
    this.nomBt = "Bouton valider";
    this.titleBt = "Bouton permettant à l'internaute de valider sa saisie.<br/>En cliquant sur ce bouton, l'internaute valide le formulaire. Celui-ci disparaît alors et un texte de remerciement personnalisé s'affiche.<br/>Si vous ne mettez pas de bouton <b>Valider</b>, ou si l'internaute ne clique pas dessus, le formulaire sera marqué comme « Non finalisé » (mais toutes ses réponses seront bien enregistrée)."
    this.labelCtrl = "Envoyer"
    this.typeDevExpress = "dxButton"


    // =========================================================
    // Surcharge mCreateElement
    // =========================================================

    var mCreateElementParent = this.mCreateElement;

    this.mCreateElement = function () {

        // Appel de la méthode du parent
        mCreateElementParent.call(Me);

        // =====================================================
        // AJOUT PERSONNEL DE LA CLASSE FILLE
        // =====================================================

        var $Td = Me.mGetTdSaisie();
        $Td.attr("textfin", "Merci pour votre réponse.<br/>Nous reviendrons vers vous rapidement.")

        Me.mAddCtrlDevExpress()
    };

    this.mAddCtrlDevExpress = function (onValueChangedDevexpress) {
        Me.mGetTdSaisie().empty()
        var ctrl = $("<div class='ctrldevexpress " + Me.mGetTypeCtrlDevexpress() + " electrl" + Me.mGetIndexdevexpress() + "' style='font-weight:bold;'/>").appendTo(Me.mGetTdSaisie()).dxButton({
            text: Me.mGetTdSaisie().attr("label"),
            onClick: function (e) {
                if (onValueChangedDevexpress) onValueChangedDevexpress(ctrl, Me.mGetTdSaisie().attr("indexdevexpress"), Me.mGetTdSaisie().attr("tri"), Me.mGetTdSaisie().attr("typedevexpress"), "", Me.mGetTdSaisie().attr("typchamp"), Me.mGetTdSaisie().attr("label"), Me.mGetTdSaisie().attr("textfin").replace(/<br\s*\/?>/gi, '\n'))
            }
        }).dxButton("instance")
    }


    // =========================================================
    // Surcharge mAddCtrlSaisie
    // =========================================================

    var mAddCtrlSaisieParent = this.mAddCtrlSaisie;

    this.mAddCtrlSaisie = function (contentElement) {

        // Appel de la méthode du parent
        mAddCtrlSaisieParent.call(Me, contentElement);

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Texte affiché à la validation du formulaire :</td>").appendTo(contentElement)
        $("<div style='width:100%;font-size:100%;font-family:barlow condensed;' class=''>Ce texte s'affichera à la place du formulaire quand l'utilisateur validera le formulaire en cliquant sur le bouton.</td>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxTextArea({
            label: "",
            labelMode: "floating",
            value: Me.mGetTdSaisie().attr("textfin").replace(/<br\s*\/?>/gi, '\n'),
            placeholder: (Me.nomWidget != "dxwidgetformbtvalide" ? "Titre de la zone de saisie..." : "Texte du bouton"),
            onValueChanged: function (value) {
                Me.mGetTdSaisie().attr("textfin", (!value ? "" : value.replace(/\n/g, '<br>')))
                option.onValueChanged()
            }
        }).dxTextArea("instance")
    };
};